export default __webpack_public_path__ + "static/media/undraw_budget.37dca574.png";